// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { slideshowStyles } from "@sc/Overrides/Widgets/Basic/Slideshow";
import { color, dotBttonStyles, ellipsis, mergeWithCss, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

slideshowStyles.carouselContainer = {
    ...mergeWithCss(slideshowStyles.carouselContainer, {
        css: css`
            border-radius: 4px;
        `,
    }),
};

slideshowStyles.slideshowWrapper = {
    css: css`
        position: relative;
    `,
};

slideshowStyles.slideCenteringWrapperStyles = {
    css: css`
        max-width: 55%;
        ${xScreen("lte", "md")} {
            max-width: 100%;
        }
    `,
};

slideshowStyles.slideContentWrapper = {
    ...mergeWithCss(slideshowStyles.slideContentWrapper, {
        css: css`
            color: ${color("text.main")};
            border-radius: 4px;
            ${xScreen("lte", "md")} {
                background-color: unset;
                flex-direction: column;
                && {
                    background-image: none;
                    min-height: initial;
                }
            }
        `,
    }),
};

slideshowStyles.slideOverlayWrapper = {
    css: css`
        display: flex;
        align-items: baseline;
        justify-content: start;
        flex-grow: 1;
        && {
            width: 100%;
            ${xScreen("lte", "md")} {
                background-color: ${({ backgroundColor }: any) => backgroundColor};
                padding: 20px 16px;
                flex-grow: 1;
            }
        }
    `,
};

slideshowStyles.headingText = {
    css: css`
        &&& {
            ${TypographyStyle} {
                line-height: 49px;
                font-size: 36px;
                margin-bottom: 16px;
                ${ellipsis(3)};
                ${xScreen("lte", "md")} {
                    line-height: 38px;
                    font-size: 28px;
                }
            }
        }
    `,
};

slideshowStyles.subheadingText = {
    css: css`
        &&& {
            ${TypographyStyle} {
                line-height: 28px;
                margin-bottom: 20px;
                font-size: 20px;
            }
        }
    `,
};

slideshowStyles.slideButton = {
    ...slideshowStyles.slideButton,
    sizeVariant: "large",
};

slideshowStyles.dotButton = {
    ...dotBttonStyles,
};

slideshowStyles.paginationWrapper = {
    css: css`
        margin-bottom: 4px;
        position: absolute;
        bottom: 10px;
        left: 50%;
        transform: translate(-50%, 0);
        ${xScreen("lte", "md")} {
            position: static;
            transform: none;
            margin-bottom: 0;
        }
    `,
};

slideshowStyles.paginationContentWrapper = {
    css: css`
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 13px;
        background-color: ${color("common.black", 0.66)};
        border-radius: 17px;
        padding: 8px;
        width: fit-content;
        ${xScreen("lte", "md")} {
            background-color: transparent;
            padding: 0;
            margin-top: 16px;
        }
    `,
};
slideshowStyles.dotsContainerWrapper = {
    css: css`
        display: flex;
        justify-content: center;
        width: 100%;
    `,
};

slideshowStyles.prevArrowWrapper = {
    css: css`
        display: flex;
    `,
};

slideshowStyles.nextArrowWrapper = {
    css: css`
        display: flex;
    `,
};

slideshowStyles.iconProps = {
    color: "common.white",
    size: 17,
    css: css`
        cursor: pointer;
        &:hover {
            color: ${color("common.ui8")};
        }
        ${xScreen("lte", "md")} {
            color: ${color("primary")};
        }
    `,
};

slideshowStyles.pictureWrapper = {
    css: css`
        display: none;
        ${xScreen("lte", "md")} {
            display: block;
        }
        div[class^="LazyImageStyle"] {
            display: flex;
            justify-content: end;
            picture {
                display: flex;
            }
        }
    `,
};
